"s44yg";
export const menuWrapper = "m1grd58z";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");